import axios from 'axios';
import { redirectToLogin } from '../utils/globalUtils';
import baseURL, { API_PREFIX } from './server';
import { apiTrace } from '../utils/apiTrace';
import { attachPayloadCrypto } from './payloadCrypto';
import { Buffer } from 'buffer';
const axiosInstance = axios.create({
  baseURL: `${baseURL}/api${API_PREFIX}/dashboard/v1`,
  headers: {
    Accept: '*/*',
    'Content-Type': 'application/json'
  },
  withCredentials: true
});

// Payload encryption (FSP-5412). Registered before the interceptors below on purpose: axios runs
// response interceptors in registration order, so this one opens a sealed body before the handlers
// below read it, and retries a 409 from an expired session before anything can surface it to the
// user. It is inert unless the gateway reports this tenant as enabled.
// No gatewayBaseUrl on purpose: the library derives `${window.location.origin}/api/gw`
// itself, which is correct for every tenant domain. Passing one overrides that.
attachPayloadCrypto(axiosInstance, { axios });

if (sessionStorage.getItem('authorization')) {
  const token = sessionStorage.getItem('authorization');
  const decryptedToken = Buffer.from(token, 'base64').toString('utf-8');
  axiosInstance.defaults.headers.common['authorization'] = decryptedToken;
}
axiosInstance.interceptors.response.use(
  (response) => {
    if (response.headers?.authorization) {
      const encryptedToken = Buffer.from(response.headers.authorization, 'utf-8').toString(
        'base64'
      );
      sessionStorage.setItem('authorization', encryptedToken);
      axiosInstance.defaults.headers.common['authorization'] = Buffer.from(
        encryptedToken,
        'base64'
      ).toString('utf-8');
    }
    apiTrace(response);
    return response;
  },
  (error) => {
    if (error?.response?.status === 401) {
      redirectToLogin();
    }
    return Promise.reject(error);
  }
);
export default axiosInstance;
